import { onOpenChatPopup } from 'shared/containers/AsideContacts/NewbuildingConsultantMessageButtonContainer/analytics/analytics';
import { EChatRole } from 'shared/repositories/newbuilding-consultants/entities/chat_user/ChatUser';
import { ESourcePage } from 'shared/repositories/newbuilding-consultants/entities/get_or_create_chat/V1GetOrCreateChatRequest';
import { getPageData } from 'shared/selectors';
import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { selectTrackingUrl } from 'shared/selectors/offerData/selectTrackingUrl';
import { fetchConsultantCianChat } from 'shared/services/fetchConsultantCianChat/fetchConsultantCianChat';
import { IThunkActionCreator } from 'shared/store';

import { closeConsultantCianChat, openConsultantCianChat, openErrorMessage, setChatLoading } from './actions';

export const onConsultantCianCloseNoAuth = (): IThunkActionCreator => {
  return dispatch => {
    dispatch(closeConsultantCianChat());
  };
};

export const requestChat = (): IThunkActionCreator<Promise<void>> => {
  return async (dispatch, getState, context) => {
    dispatch(setChatLoading());
    const state = getState();
    const customLabel = selectTrackingUrl(state);
    const pageData = getPageData(state);
    const regionId = regionIdSelector(state);
    const fullUrl = `https://${pageData.subdomain}.cian.ru/${pageData.dealType}/${pageData.offerType}/${pageData.offerId}`;

    const { httpApi, logger } = context;
    const data = await fetchConsultantCianChat({
      httpApi,
      logger,
      parameters: { pageUrl: fullUrl, sourcePage: ESourcePage.OfferCard },
    });

    /* istanbul ignore else */
    if (data && data.chatId) {
      const user = data.users.find(user => user.chatRole === EChatRole.Initiator);
      dispatch(openConsultantCianChat(data.chatId));
      if (regionId !== undefined) {
        onOpenChatPopup({ customPageURL: customLabel, chatId: data.chatId, botId: 3, ownerId: user?.userId, regionId });
      }
    } else {
      dispatch(openErrorMessage());
    }
  };
};
